<div id="full-width-modal-modalNewConversationTitle" class="modal fade show" tabindex="-1"
  aria-labelledby="modalNewConversationTitle" style="display: block;" aria-modal="true" role="dialog" #modalContainer>
  <div class="modal-dialog modal-dialog-scrollable modal-full-width">
    <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title">{{ 'plans.modal.title' | translate }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
      </div>

      <div class="modal-body" style="max-height: 100vh">
        <div class="billing-toggle">
          <button [class.active]="billingCycle === 'monthly'" (click)="setBillingCycle('monthly')">
            {{ 'plans.modal.cycleMonthly' | translate }}
          </button>
          <button [class.active]="billingCycle === 'semiannual'" (click)="setBillingCycle('semiannual')">
            {{ 'plans.modal.cycleSemiannual' | translate }}
          </button>
          <button [class.active]="billingCycle === 'yearly'" (click)="setBillingCycle('yearly')">
            {{ 'plans.modal.cycleYearly' | translate }}
          </button>
        </div>
        <div class="plans-modal">

          <div class="plans-container">
            @for (plan of plans; track plan.name) {
            <div class="plan-card" [class.recommended]="plan.recommended">
              @if (plan.recommended) {
              <div class="recommended-badge badge bg-primary">
                <i class="ri-star-fill"></i>
                {{ 'plans.modal.recommended' | translate }}
              </div>
              }

              <div class="plan-header">
                <h3>{{ plan.name }}</h3>
                <p class="plan-description">{{ plan.description | translate }}</p>
              </div>

              <div class="plan-pricing">
                @if (billingCycle === 'monthly') {
                <span class="price">R$ {{ getPrice(plan) | number:'1.0-0' }}</span>
                <span class="period">{{ 'plans.modal.periodMonthly' | translate }}</span>
                } @else {

                <span class="price">R$ {{ getDiscountedTotal(plan) | number:'1.2-2' }} <span class="full-total">R$ {{
                    getFullTotal(plan) | number:'1.0-0' }} <div class="ms-1 badge campaign-badge is-ok discount-badge">{{ getDiscountPercent() }}%
                      {{ 'plans.modal.discountOff' | translate }}
                    </div></span></span>
                <span class="period">{{ getPeriodLabel() }}</span>
                }
                <div class="users-count">{{ 'plans.modal.usersCount' | translate:{ count: plan.users } }}</div>
              </div>

              <!-- <div class="plan-limits">
                <div class="limit-item">
                  <span class="limit-value">{{ plan.limits.campaigns }} <span class="limit-label">Contatos + Campanhas +
                      Integrações (disparos) por
                      mês</span></span>

                </div>
                <div class="limit-item">
                  <span class="limit-value">{{ plan.limits.integrations }} <span class="limit-label">Integrações
                      (requisições)
                      por mês</span></span>

                </div>
                <div class="limit-item">
                  <span class="limit-value">{{ plan.limits.contacts }} <span class="limit-label">Contatos na
                      plataforma</span></span>

                </div>
              </div> -->

              <div class="plan-features">
                <p class="features-title">{{ 'plans.modal.featuresTitle' | translate }}</p>
                <ul>
                  @for (feature of plan.features; track feature) {
                  <li>
                    <i class="ri-check-line"></i>
                    {{ feature | translate }}
                  </li>
                  }
                </ul>
              </div>

              <button class="btn btn-primary purchase-btn" (click)="onPurchase(plan)">
                {{ !loading ? ('plans.modal.startNow' | translate) : '' }}
                @if (loading) {
                <mat-spinner class="mr-4" [diameter]="25" [color]="'accent'" mode="indeterminate"></mat-spinner>
                }
              </button>
            </div>
            }
          </div>


        </div>
      </div>

      <div class="modal-footer">
        <button class="continue-free" (click)="onContinueFree()">
          {{ 'plans.modal.continueFree' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>